import { render } from "./TerminalDetails.vue?vue&type=template&id=8bf729c4&ts=true"
import script from "./TerminalDetails.vue?vue&type=script&lang=ts"
export * from "./TerminalDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__